import React from 'react';
import { QuickTermsAndConditionsProps } from 'components/termsAndConditions/types';
import { useIsSmallViewportWidth } from 'hooks/use-is-small-viewport-width.hook';
import { MobileModal } from './mobile';
import { DesktopModal } from './desktop';

export const TermsAndConditionsTextModal = ({ handleChangeStep }: QuickTermsAndConditionsProps) => {
  const isMobileDevice = useIsSmallViewportWidth();

  return isMobileDevice ? (
    <MobileModal handleChangeStep={handleChangeStep} />
  ) : (
    <DesktopModal handleChangeStep={handleChangeStep} />
  );
};
